import { useCreateInfluencer, useUpdateInfluencer } from '../../data';
import InfluencerForm from './InfluencerForm';

export const CreateInfluencer = (props) => {
  const [createInfluencer, { isLoading: isCreating }] = useCreateInfluencer();
  const handleSubmit = async (values) => {
    const influencer = await createInfluencer(values);

    props.onSubmit(influencer);
  };
  return (
    <InfluencerForm
      {...props}
      title={'Add Influencer'}
      onSubmit={handleSubmit}
      loading={isCreating}
    />
  );
};

export const UpdateInfluencer = (props) => {
  const [updateInfluencer, { isLoading: isUpdating }] = useUpdateInfluencer();
  const handleSubmit = async (values) => {
    await updateInfluencer(values);
    props.onClose();
  };
  return (
    <InfluencerForm
      {...props}
      title={'Edit Influencer'}
      loading={isUpdating}
      onSubmit={handleSubmit}
    />
  );
};
